import React from 'react';
import { CheckIcon } from 'lucide-react';
export function WhatYouGet() {
  const features = [{
    title: 'The 48-Hour Rapid Protocol',
    description: 'A step-by-step schedule from morning to night. No guesswork involved.'
  }, {
    title: 'The "Hidden Inflamers" Audit',
    description: '3 common "health foods" you must stop eating immediately to stop the bloat.'
  }, {
    title: 'The Day 1 Active Rehydration Formula',
    description: 'How to drink water so it actually cleanses your cells instead of sitting in your stomach.'
  }, {
    title: 'The Day 2 Sequential Meal Technique',
    description: 'Exactly what order to eat your food to prevent re-bloating before your event.'
  }, {
    title: 'Emergency Grocery List',
    description: 'The 7 low-cost items you can find at any local store to start the protocol tonight.'
  }];
  return <section className="py-24 bg-white" data-id="element-209">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-210">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-211">
          <div data-id="element-212">
            <h2 className="text-3xl md:text-4xl font-serif text-stone-900 mb-6" data-id="element-213">
              Everything You Need to Deflate in 48 Hours
            </h2>
            <p className="text-lg text-stone-600 mb-10" data-id="element-214">
              This isn't a 300-page textbook on gut microbiomes. It's a
              tactical, paste-ready action plan designed for immediate
              execution.
            </p>

            <ul className="space-y-6" data-id="element-215">
              {features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-216">
                  <div className="flex-shrink-0 mt-1" data-id="element-217">
                    <div className="w-6 h-6 rounded-full bg-forest-100 flex items-center justify-center" data-id="element-218">
                      <CheckIcon className="w-4 h-4 text-forest-700" data-id="element-219" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-220">
                    <h4 className="text-lg font-medium text-stone-900" data-id="element-221">
                      {feature.title}
                    </h4>
                    <p className="mt-1 text-stone-600" data-id="element-222">{feature.description}</p>
                  </div>
                </li>)}
            </ul>
          </div>

          <div className="relative" data-id="element-223">
            <div className="absolute inset-0 bg-stone-100 rounded-3xl transform -rotate-3 scale-105 -z-10" data-id="element-224"></div>
            <img src="https://cdn.magicpatterns.com/uploads/vV6bTtWhKGojY3xVMmoLhx/heylloyd-image-1774062337432.png" alt="Planner Preview" className="w-full h-auto rounded-3xl shadow-editorial border border-stone-200" data-id="element-225" />
          </div>
        </div>
      </div>
    </section>;
}